import styled from "styled-components";

export const DashboardNavbarContainer = styled.nav`
   background-color: #fff;
   height: 65px;
   line-height: 65px;
   box-shadow: 1px 1px 11px rgb(0 0 0 / 10%);
   position: sticky;
   top: 0;
   left: 0;
   z-index: 500;
   grid-area: navbar;
   display: flex;
   justify-content: flex-end;
   padding: 10px 25px;
`;
